module.exports = __webpack_public_path__ + "assets/img/3.ebb8ee2a.svg";